// The upload flow's `:step` route segment is the single source of truth for the
// active stepper index, so browser back/forward can't desync the stepper from the
// step that's actually rendered. Only file-select (no segment) and preview are
// navigable steps; "Upload Complete" (STEPS[2]) is a decorative stepper label with
// no submitButton, never a destination, so anything but `preview` maps to step 0.
const STEP_INDEX_BY_PARAM = { preview: 1 }

export const getActiveStepFromParams = params => STEP_INDEX_BY_PARAM[params?.step] ?? 0
